import React from 'react'
import { useTranslation } from 'react-i18next'
import lmsLogo from '../../../assets/images/desire2learnnew.png'
import '../integration.scss'
import { useHistory } from 'react-router'
import { INTEGRATION_TYPE } from '../../../config/index'
import { Image } from 'react-bootstrap'

const Desire2learnIntegration = (props: any) => {
  const { t } = useTranslation('translation')
  const history = useHistory()

  const clickIntegration = () => {
    history.push(INTEGRATION_TYPE.replace(':type', 'desire2learn'))
  }

  return (
    <>
      <div
        role="button"
        className="integration-item"
        onClick={(e: any) => {
          e.stopPropagation()
          clickIntegration()
        }}
      >
        <div className="container-fluid d-inline-flex justify-content-between align-items-center p-0">
          <Image src={lmsLogo} />
        </div>
        <div className="integrationBox-heading">
          <h4>D2L Brightspace</h4>
        </div>
        <div>{t('A flexible and powerful learning innovation platform.')}</div>
        <div className="configure-btn">
          <button
            className="btn btn-primary tw-ml-auto"
            onClick={() => clickIntegration()}
          >
            {t('Configure')}
          </button>
        </div>
      </div>
    </>
  )
}

export default Desire2learnIntegration
